import { Box, styled } from "@mui/material";

export const MyTasksWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  padding: "0px 120px 0px 120px",
  gap: "80px",
  width: "100%",
  maxWidth: theme.breakpoints.values.xl,
  [theme.breakpoints.down("xl")]: {
    padding: "0px 120px 0px 120px",
  },
  [theme.breakpoints.down("lg")]: {
    padding: "0px 60px 0px 60px",
  },

  [theme.breakpoints.down("sm")]: {
    padding: "0px 40px 0px 40px",
  },

  "& .filepond--credits": {
    display: "none",
  },
})) as typeof Box;

export const MyTasksWrapperLeft = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "40px",

  [theme.breakpoints.down("xl")]: {
    width: "100%",
  },
  [theme.breakpoints.down("lg")]: {
    width: "100%",
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
})) as typeof Box;
